import React from 'react';
import { RoutesProvider } from '@shared/core';
import { BurgerMenu } from './components/BurgerMenu/BurgerMenu';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { LazyBurgerMenuDrawer } from './BurgerMenuDrawer.lazy';
import { EventType } from '@graphql/generated-base';
import type { UniversalBurgerMenuEmbedHandlers } from './UniversalBurgerMenu.types';

const Root = ({
  eventInfo,
  embed,
  children,
}: {
  eventInfo: {
    eventType: EventType;
    eventHandle: string;
    eventId: string;
  };
  embed?: UniversalBurgerMenuEmbedHandlers;
  children: React.ReactNode;
}) => {
  const isMobile = useIsMobileScreen();

  return (
    <BurgerMenu
      enableMobileFirst={isMobile}
      embed={embed}
      renderDrawer={drawer => (
        <LazyBurgerMenuDrawer
          {...drawer}
          eventInfo={eventInfo}
          embed={embed}
        />
      )}
    >
      {children}
    </BurgerMenu>
  );
};

export const UniversalBurgerMenu: React.FC<{ eventHandle?: string; embed?: UniversalBurgerMenuEmbedHandlers }> = ({ children, eventHandle, embed }) => {
  const eventInfo = useEventInfo();

  const handle = eventHandle || eventInfo?.eventHandle || '';
  const basicEventInfo = {
    eventType: eventInfo?.eventInfo?.eventType || EventType.wedding,
    eventHandle: handle,
    eventId: eventInfo?.eventInfo?.eventId || '',
  };

  return (
    <RoutesProvider handle={handle}>
      <Root
        eventInfo={basicEventInfo}
        embed={embed}
      >
        {children}
      </Root>
    </RoutesProvider>
  );
};
